import React from 'react';

import Spinner from '@/components/UI/Spinner';

interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="pa6 tc bg-white bb b--moon-gray">
      <div className="pa3 dib tc">
        <Spinner size="large" color="blue" className="dib" />
        <h3 className="lh-title f4 basier-reg normal pv3">{message}</h3>
      </div>
    </div>
  );
};
